// extracted by mini-css-extract-plugin
export default {"dancerGridLocation":"dancer-grid-location_dancerGridLocation__Kcu4S"};